/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-11 10:32:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-30 17:55:09
 * @FilePath: /src/app/(staitc-page)/our-story-zeelool/components/SwiperComponent.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

'use client';

import Image from '@/components/Image';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useMediaQuery, useTheme } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import { useContext, useEffect, useState } from 'react';
import { Mousewheel, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './SwiperComponent.module.css';

export default function SwiperComponent() {
  const t = useTranslations('our-story-zeelool');
  const [swiperHeight, setSwiperHeight] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { deviceType } = useContext(ResponsiveContext);

  const inAppH5 = [EPlatform.ANDROID, EPlatform.IOS].includes(deviceType);

  useEffect(() => {
    // 在客户端计算高度，排除头部高度
    const calculateHeight = () => {
      const height = document.documentElement.clientHeight;
      // PC端减去107px的头部，移动端不需要减
      if (inAppH5) {
        setSwiperHeight(height);
      } else if (isMobile) {
        setSwiperHeight(height - 84);
      } else {
        setSwiperHeight(height - 107);
      }
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight);

    return () => {
      window.removeEventListener('resize', calculateHeight);
    };
  }, [isMobile]);

  return (
    <div className={styles.swipers} style={{ height: `${swiperHeight}px` }}>
      <Swiper
        direction="vertical"
        slidesPerView={1}
        spaceBetween={0}
        mousewheel
        pagination={{
          clickable: true,
        }}
        modules={[Mousewheel, Pagination]}
        className={styles.swiper}
      >
        {/* 第一屏：品牌故事 */}
        <SwiperSlide className={styles.swiper1}>
          {!isMobile && (
            <>
              <Image
                src="/static-page/our-story/yuan@2x.png"
                alt={t('circleBackgroundAlt')}
                width={337}
                height={626}
                className={styles.img1}
              />
              <Image
                src="/static-page/our-story/eyeglasses@2x.png"
                alt={t('eyeglassesAlt')}
                width={486}
                height={514}
                className={styles.img2}
              />
            </>
          )}
          <div className={`${styles.p1} font-bb`}>{t('brandStory')}</div>
          <div className="md:w-[1000px] md:mx-auto mt-[23px] md:mt-[43px] pr-[40px] md:pr-0 pl-[25px] md:pl-0 text-[14px] md:text-[20px] font-ir text-primary-black leading-[24px] md:leading-[32px] relative z-10 text-left md:text-center">
            {t('brandStoryParagraph1')}
          </div>
          <div className={`${styles.p3} font-bb`}>{t('brandStoryQuestion')}</div>
          <div className="md:w-[1000px] md:mx-auto  mt-[23px] md:mt-[43px] pr-[40px] md:pr-0 pl-[25px] md:pl-0 text-[14px] md:text-[20px] font-ir text-primary-black leading-[24px] md:leading-[32px] relative z-10 text-left md:text-center">
            {t('brandStoryParagraph2')}
          </div>
          {isMobile && (
            <Image
              src="/static-page/our-story/eyeglasses-bg@2x_mobile.png"
              alt={t('eyeglassesBackgroundAlt')}
              width={158}
              height={190}
              className={`${styles.mobileImg1} absolute bottom-0 right-0 w-[158px] h-[290px]`}
            />
          )}
        </SwiperSlide>

        {/* 第二屏：品牌理念 - PC端 */}
        {!isMobile ? (
          <SwiperSlide className={styles.swiper2}>
            <div className={styles.title}>{t('brandConceptUppercase')}</div>
            <Image
              src="/static-page/our-story/star@2x.png"
              alt={t('starAlt')}
              width={234}
              height={301}
              className={styles.img1}
            />
            <Image
              src="/static-page/our-story/xian@2x.png"
              alt={t('lineAlt')}
              width={565}
              height={216}
              className={styles.img2}
            />
            <div className={styles.swiper2l}>
              <div className={styles.p1}>{t('fashion')}</div>
              <div className="mt-[23px] w-[80%]  md:mt-[50px] pr-[40px] md:pr-0 pl-[25px] md:pl-[60px] text-[14px] md:text-[18px] font-ir text-primary-black md:text-white/50 leading-[24px] md:leading-[28px] relative z-10">
                {t('fashionDescription')}
              </div>
            </div>
            <div className={styles.swiper2c}>
              <div className={styles.p1}>{t('costSaving')}</div>
              <div className="mt-[23px] w-[80%]  md:mt-[50px] pr-[40px] md:pr-0 pl-[25px] md:pl-[60px] text-[14px] md:text-[18px] font-ir text-primary-black md:text-white/50 leading-[24px] md:leading-[28px] relative z-10">
                {t('costSavingDescription')}
              </div>
            </div>
            <div className={styles.swiper2r}>
              <div className={`${styles.p1} !text-[#ff4d4e]`}>{t('selfExpression')}</div>
              <div className="mt-[23px] w-[80%] md:mt-[50px] pr-[40px] md:pr-0 pl-[25px] md:pl-[60px] text-[14px] md:text-[18px] font-ir text-primary-black md:text-white/50 leading-[24px] md:leading-[28px] relative z-10">
                {t('selfExpressionDescription')}
              </div>
            </div>
          </SwiperSlide>
        ) : (
          <>
            {/* 移动端拆分为三个滑块 */}
            <SwiperSlide className={styles.swiper2Mobile}>
              <div className={styles.p1}>{t('brandConcept')}</div>
              <div className={styles.p2}>{t('fashion')}</div>
              <div className={styles.p3}>{t('fashionDescription')}</div>
              <Image
                src="/static-page/our-story/jihe@2x.png"
                alt={t('geometricShapesAlt')}
                width={163}
                height={168}
                className={styles.mobileImg1}
              />
            </SwiperSlide>

            <SwiperSlide className={styles.swiper3Mobile}>
              <div className={styles.p1}>{t('brandConcept')}</div>
              <div className={styles.p2}>{t('costSaving')}</div>
              <div className={styles.p3}>{t('costSavingDescription')}</div>
              <Image
                src="/static-page/our-story/jihe@2x.png"
                alt={t('geometricShapesAlt')}
                width={163}
                height={168}
                className={styles.mobileImg1}
              />
            </SwiperSlide>

            <SwiperSlide className={styles.swiper4Mobile}>
              <div className={styles.p1}>{t('brandConcept')}</div>
              <div className={`${styles.p2} !text-[#ff4d4e]`}>{t('selfExpression')}</div>
              <div className={styles.p3}>{t('selfExpressionDescription')}</div>
              <Image
                src="/static-page/our-story/jihe@2x.png"
                alt={t('geometricShapesAlt')}
                width={163}
                height={168}
                className={styles.mobileImg1}
              />
              <Image
                src="/static-page/our-story/xing@2x.png"
                alt={t('starAlt')}
                width={280}
                height={145}
                className={styles.mobileImg2}
              />
            </SwiperSlide>
          </>
        )}

        {/* 第三屏：品牌简介 */}
        <SwiperSlide className={styles.swiper3}>
          {!isMobile && (
            <Image
              src="/static-page/our-story/Line@2x.png"
              alt={t('lineAlt')}
              width={127}
              height={298}
              className={styles.img1}
            />
          )}
          {!isMobile && (
            <Image
              src="/static-page/our-story/eyeglasses-bg@2x.png"
              alt={t('eyeglassesBackgroundAlt')}
              width={1920}
              height={400}
              className={styles.img2}
            />
          )}
          <div className={`${styles.p1} font-bb`}>{t('brandProfile')}</div>
          <div className="md:w-[1000px] md:mx-auto  mt-[23px] md:mt-[43px] pr-[40px] md:pr-0 pl-[25px] md:pl-0 text-[14px] md:text-[20px] font-ir text-primary-black leading-[24px] md:leading-[32px] relative z-10 text-left md:text-center">
            {t('brandProfileDescription')}
          </div>
          {isMobile && (
            <Image
              src="/static-page/our-story/glasses@2x.png"
              alt={t('glassesAlt')}
              width={375}
              height={235}
              className={styles.mobileImg1}
            />
          )}
        </SwiperSlide>

        {/* 第四屏：购买号召 */}
        <SwiperSlide className={styles.swiper4}>
          <Image
            src="https://s3.zeelool.com/admin/shop/home/2a1e01e7f71698f12a598739898362a1.png"
            alt={t('buyGlassesAtZeeloolAlt')}
            width={isMobile ? 242 : 381}
            height={isMobile ? 242 : 381}
            className={styles.img1}
          />
          <div className={styles.p1}>{t('buyGlassesAtZeelool')}</div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
